import { Component, input, output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { ModalComponent } from '@abp/ng.theme.shared';
import { ZnButton } from '../zn-button/zn-button';

@Component({
  selector: 'lib-stepper-success-modal',
  standalone: true,
  imports: [ModalComponent, LocalizationPipe, ZnButton],
  template: `
    <abp-modal
      [visible]="isVisible()"
      (visibleChange)="onVisibleChange($event)"
      (closed)="onVisibleChange(false)"
      [suppressUnsavedChangesWarning]="true"
      [options]="{ windowClass: 'zn-modal-success' }">
      <ng-template #abpHeader></ng-template>
      <ng-template #abpBody>
          <div class="icon-wrap" aria-hidden="true">
            <svg class="success-svg" viewBox="0 0 100 100">
              <circle class="success-circle" cx="50" cy="50" r="40" fill="none"></circle>
              <path class="success-check" d="M33 52 L45 64 L68 41" fill="none"></path>
            </svg>
          </div>
          <h3>{{ message() | abpLocalization }}</h3>
      </ng-template>
      <ng-template #abpFooter>
        <zn-button
          [label]="closeLabel() | abpLocalization"
          type="secondary"
          size="large"
          (click)="onVisibleChange(false)"
          (keydown.enter)="onVisibleChange(false)"
        ></zn-button>
      </ng-template>
    </abp-modal>
  `
})
export class StepperSuccessModal {
  isVisible = input(false);
  message = input('Default message');
  closeLabel = input('LanguageService::Close');
  isVisibleChange = output<boolean>();

  onVisibleChange(value: boolean): void {
    this.isVisibleChange.emit(value);
  }
}
